import  React, { useCallback } from 'react';
import { CoverDataItem } from '../../../../utils/models';
import { getAnomalyId } from '../../../../utils/utilities';

interface AnomalyDescriptionProps {
    anomaly: { id: number; description: CoverDataItem[] };
    lineNumberID?: number;
    anomalyIndex?: number;
}

const AnomalyDescription: React.FC<AnomalyDescriptionProps> = ({ anomaly, anomalyIndex, lineNumberID }): any => {
    const renderID = useCallback((descriptionIndex: number) => {
        if (lineNumberID && anomalyIndex) {
            return `${getAnomalyId(lineNumberID, anomalyIndex)}.${descriptionIndex + 1}`
        }

        return getAnomalyId(anomaly.id, descriptionIndex + 1);
    }, [lineNumberID, anomalyIndex, anomaly.id]);

    return anomaly.description.map((description, index) => (
                <div key={description.value} className="mt-2 d-flex justify-content-start align-items-start">
                    <div className="text-start fw-bold me-1">{renderID(index)}</div>
                    <div className="text-start flex-wrap no-white-space">
                        {description.value.replace(/\s+/g, ' ')}
                    </div>
                </div>
            ));
};
 
export default AnomalyDescription;